import { breakpoints } from '../helpers/constants';
const footer = () => {
  const $footer = document.querySelector('.footer');
  if (!$footer) return;
  const $footerCols = $footer.querySelectorAll('.footer-nav');
  const $footerHeadlines = $footer.querySelectorAll('.footer-nav > header');
  const toggleAll = target => {
    $footerHeadlines.forEach($header => {
      if (target.isEqualNode($header)) return;
      $header.classList.remove('toggled');
    });
  };
  function navColCollapse() {
    $footerCols.forEach($col => {
      const $headline = $col.querySelector('.header-container');
      const $content = $col.querySelector('ul');
      if (!$headline || !$content) return;
      if (window.innerWidth < breakpoints.md) {
        $headline.classList.add('toggle');
        $headline.classList.remove('toggled');
        $headline.onclick = () => {
          $headline.classList.toggle('toggled');
          toggleAll($headline);
        };
      } else {
        $headline.classList.remove('toggle');
        $headline.onclick = () => false;
      }
    });
  }
  navColCollapse();
  window.addEventListener('resize', navColCollapse);
};
export default footer;